// extracted by mini-css-extract-plugin
export default {"slickArrow":"InviteModalCarousel_slickArrow__-xRh+","slickPrev":"InviteModalCarousel_slickPrev__OnInT","slickNext":"InviteModalCarousel_slickNext__pky2C"};